export const AUCTION_FORMAT = {
    SALEYARD: 'SALEYARD',
    SEQ: 'SEQ',
    HYBRID: 'HYBRID'
}

export const AUCTION_FORMAT_LABEL = {
    SALEYARD: 'Saleyard',
    SEQ: '100% Online',
    HYBRID: 'Hybrid On-Farm'
}

export const START_PRICE_TYPE = {
    START_PRICE: 0,
    CALL_PRICE: 1
}

export const BIDR_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY, HH:mm:ss'
    },
    display: {
        dateInput: 'DD/MM/YYYY, HH:mm:ss',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
}

export const DEFAULT_STARTING_BUYER_NUMBER = 900

export const SCALE_ONLY_STABLE_WEIGHT = true
